module.exports = __webpack_public_path__ + "images/instructor-jeff-li-mobile.webp";